<template>
  <div ref="frame" class="news-crop-img">
    <img
      ref="img"
      :src="imageSrc"
      :alt="alt"
      class="news-crop-img__el"
      draggable="false"
      @load="onLoad"
    >
  </div>
</template>

<script>
import {
  CAROUSEL_FRAME_W,
  getPhotoCoverLayout,
  parseCropZoom,
  clampPhotoPan,
  resetPanCentered,
} from '@/utils/carouselCropMath';

export default {
  name: 'NewsCropImageView',
  props: {
    imageUrl: {
      type: String,
      default: '',
    },
    cropZoom: {
      type: [Number, String],
      default: 1,
    },
    cropPanX: {
      type: [Number, String],
      default: null,
    },
    cropPanY: {
      type: [Number, String],
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      naturalW: 0,
      naturalH: 0,
      displayPanX: 0,
      displayPanY: 0,
      ro: null,
    };
  },
  computed: {
    imageSrc() {
      return this.imageUrl || '';
    },
    slideLike() {
      return {
        cropZoom: this.cropZoom,
        cropPanX: this.cropPanX,
        cropPanY: this.cropPanY,
      };
    },
  },
  watch: {
    slideLike: {
      deep: true,
      handler() {
        if (this.naturalW && this.naturalH) {
          this.syncPanFromSlide();
          this.apply();
        }
      },
    },
    imageUrl() {
      this.naturalW = 0;
      this.naturalH = 0;
    },
  },
  mounted() {
    const el = this.$refs.frame;
    if (el && typeof ResizeObserver !== 'undefined') {
      this.ro = new ResizeObserver(() => this.apply());
      this.ro.observe(el);
    }
  },
  beforeDestroy() {
    if (this.ro && this.$refs.frame) {
      this.ro.unobserve(this.$refs.frame);
    }
    this.ro = null;
  },
  methods: {
    onLoad() {
      const img = this.$refs.img;
      if (!img) return;
      this.naturalW = img.naturalWidth;
      this.naturalH = img.naturalHeight;
      this.syncPanFromSlide();
      this.apply();
    },
    syncPanFromSlide() {
      const slide = this.slideLike;
      const z = parseCropZoom(slide.cropZoom);
      const hasPan =
        slide.cropPanX !== undefined &&
        slide.cropPanX !== null &&
        slide.cropPanY !== undefined &&
        slide.cropPanY !== null &&
        Number.isFinite(Number(slide.cropPanX)) &&
        Number.isFinite(Number(slide.cropPanY));
      if (!hasPan) {
        const r = resetPanCentered(this.naturalW, this.naturalH, z);
        this.displayPanX = r.panX;
        this.displayPanY = r.panY;
        return;
      }
      const c = clampPhotoPan(
        Number(slide.cropPanX),
        Number(slide.cropPanY),
        this.naturalW,
        this.naturalH,
        z,
      );
      this.displayPanX = c.panX;
      this.displayPanY = c.panY;
    },
    kDisplay() {
      const frame = this.$refs.frame;
      if (!frame || !frame.clientWidth) return 1;
      return frame.clientWidth / CAROUSEL_FRAME_W;
    },
    apply() {
      const img = this.$refs.img;
      if (!img || !this.naturalW || !this.naturalH) return;
      const z = parseCropZoom(this.slideLike.cropZoom);
      const { dispW, dispH } = getPhotoCoverLayout(this.naturalW, this.naturalH, z);
      const k = this.kDisplay();
      img.style.width = `${dispW * k}px`;
      img.style.height = `${dispH * k}px`;
      img.style.left = `${this.displayPanX * k}px`;
      img.style.top = `${this.displayPanY * k}px`;
    },
  },
};
</script>

<style scoped>
.news-crop-img {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #e8e8e8;
  border-radius: 8px;
}

.news-crop-img__el {
  position: absolute;
  left: 0;
  top: 0;
  max-width: none;
  user-select: none;
  pointer-events: none;
}
</style>
